let links = document.querySelectorAll("img[data-original-src]")
links.forEach((link)=>{
link.src=link.getAttribute("data-original-src").replace(".jpg","_1000x.jpg")
})


let links2 = document.querySelectorAll("div[data-bgset]")
links2.forEach((link)=>{
	let linkarray=link.getAttribute("data-bgset").split("?")
	let totalLink=linkarray[0].replace("x600","1600x")
 
	 
link.style.backgroundImage=`url(${totalLink})`
})

let slideshowImage = document.querySelectorAll("#section-slideshow .Slideshow__Image")
slideshowImage.forEach((slideshowImage)=>{
let attrSlideshowImage = slideshowImage.getAttribute("data-src").replace("{width}","1600")
slideshowImage.setAttribute("src",attrSlideshowImage)
})


 
$(document).on("scroll", function(){
 $('.lazy').Lazy();
     $('.ProductListWrapper img[data-src]').each(function(){
                  $(this).attr('src',$(this).attr('data-src')).removeAttr('data-src');
            });
})

 